import { useMissionsTranslation } from '../../../../ui/hooks';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ShiftDetailCard } from './ShiftDetailCard';
export const ShiftContactCard = ({ displayShiftContact, contactName, contactPhone, contactEmail }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(ShiftDetailCard, { title: t('missions.missionDetails.shiftContact') }, displayShiftContact ? (React.createElement(Box, { color: themeColors.text.subtle, "data-test": 'shift-contact-card' },
        React.createElement(Typography, { variant: 'body2' }, contactName),
        React.createElement(Typography, { variant: 'body2' }, formatPhoneNumber(contactPhone)),
        React.createElement(Typography, { variant: 'body2' }, contactEmail))) : (React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle, "data-test": 'shift-contact-card' }, t('shifts.noContactShown')))));
};
